import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { ScrollAreaScrollbarProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { reactiveOmit } from "@vueuse/core"
import { ScrollAreaScrollbar, ScrollAreaThumb } from "reka-ui"
import { cn } from "@/lib/utils"


export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollBar',
  props: {
    orientation: { default: "vertical" },
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(__props: any) {

const props = __props

const delegatedProps = reactiveOmit(props, "class")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ScrollAreaScrollbar), _mergeProps(_unref(delegatedProps), {
    class: 
      _unref(cn)('flex touch-none select-none transition-colors',
         __props.orientation === 'vertical'
           && 'h-full w-2.5 border-l border-l-transparent p-px',
         __props.orientation === 'horizontal'
           && 'h-2.5 flex-col border-t border-t-transparent p-px',
         props.class)
  }), {
    default: _withCtx(() => [
      _createVNode(_unref(ScrollAreaThumb), { class: "relative flex-1 rounded-full bg-border" })
    ]),
    _: 1
  }, 16, ["class"]))
}
}

})